export default "__VITE_ASSET__NaPPSA7Q__"